import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import vuetify from './plugins/vuetify';
import axios from 'axios';
import moment from 'moment';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')

const token = localStorage.getItem('user-token');
if (token) {
  axios.defaults.headers.common['token'] = token;
}

moment.locale('es');
